import React from 'react'
import AssistantCreate from '../../../Components/DMM/Assistant/AssistantCreate'

const index = props => {
  return <AssistantCreate />
}

export default index
